export default __webpack_public_path__ + "static/media/logo__footer-inverted.694a6054.svg";